import { Text } from '@shared/components'
import { useTheme } from 'antd-style'
import { Copy } from 'iconsax-react'

type Props = {
  isDanger?: boolean
  icon?: React.ReactNode
  label: React.ReactNode
  text?: string
} & React.HTMLAttributes<HTMLDivElement>

export const CopyableText = ({
  isDanger,
  icon,
  label,
  text,
  className,
  style,
  ...props
}: Props) => {
  const theme = useTheme()

  // Get the text content for tooltip - prefer text prop, otherwise use label
  const tooltipContent = text || label

  return (
    <div
      className={className}
      style={{
        display: 'grid',
        gridTemplateColumns: icon ? 'auto 1fr auto' : '1fr auto',
        gap: 8,
        alignItems: 'center',
        width: '100%',
        minWidth: 0,
        ...style
      }}
      {...props}
    >
      {icon && (
        <div style={{ color: theme.colorTextSecondary, display: 'flex' }}>
          {icon}
        </div>
      )}

      <Text
        style={{
          minWidth: 0,
          overflow: 'hidden'
        }}
        strong
        ellipsis={{
          tooltip: {
            title: tooltipContent
          }
        }}
        {...(isDanger && { type: 'danger' })}
      >
        {label}
      </Text>

      <Text
        style={{ lineHeight: 1 }}
        copyable={{
          text: typeof label === 'string' ? label : text,
          icon: <Copy size={16} />
        }}
      />
    </div>
  )
}
